/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function CommentResolve({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M11.462 4.883a.6.6 0 1 0-.923-.766L6.85 8.555 5.466 6.849a.6.6 0 1 0-.932.757L6.38 9.878a.6.6 0 0 0 .928.005z" /><path fill="currentColor" fillRule="evenodd" d="M13 1.4A2.6 2.6 0 0 1 15.6 4v6a2.6 2.6 0 0 1-2.6 2.6H7.652a1.4 1.4 0 0 0-.9.329l-2.673 2.248a.6.6 0 0 1-.987-.46V12.6H3A2.6 2.6 0 0 1 .4 10V4A2.6 2.6 0 0 1 3 1.4zM14.4 4A1.4 1.4 0 0 0 13 2.6H3A1.4 1.4 0 0 0 1.6 4v6A1.4 1.4 0 0 0 3 11.4h.692a.6.6 0 0 1 .6.6v1.429L5.98 12.01a2.6 2.6 0 0 1 1.673-.61H13a1.4 1.4 0 0 0 1.4-1.4z" clipRule="evenodd" /></svg>;
}
;